import { Nps, SaveNpsProps } from 'types/nps'
import { create } from 'zustand'

interface NpsStorageType {
  initialRatingNps: number
  npsToken: string | null
  npsData: Nps | null
  npsAnswer: SaveNpsProps | null
  setInitialRatingNps: (rating: number) => void
  setNpsToken: (token?: string) => void
  setNpsData: (npsData?: Nps | null) => void
  setNpsAnswer: (npsAnswer?: SaveNpsProps | null) => void
  hasNps: () => boolean
}

const initialState = {
  initialRatingNps: 0,
  npsToken: null,
  npsData: null,
  npsAnswer: null
}

const useStorageNps = create<NpsStorageType>((set, get) => ({
  ...initialState,
  setInitialRatingNps: (rating: number) =>
    set({ initialRatingNps: rating || 0 }),
  setNpsToken: (token?: string) => set({ npsToken: token }),
  setNpsData: (npsData?: Nps | null) => set({ npsData: npsData }),
  setNpsAnswer: (npsAnswer?: SaveNpsProps | null) =>
    set({ npsAnswer: npsAnswer }),
  hasNps: () => {
    const npsData = get().npsData
    if (npsData && npsData !== undefined) {
      return true
    } else {
      return false
    }
  }
}))

export default useStorageNps

